export default {
      id: "arrow-down-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "icons.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }